export default {
  classes: {
    container: 'relative p-8 mt-5 rounded bg-gray-200',
    body: 'lg:flex block flex-col md:flex-row',
  },
  variants: {},
}
